const krajPochodzenia = { t: 'Kraj pochodzenia', name: 'kraj-pochodzenia', hint: { url: '/country', select: true }}
export default krajPochodzenia